if (!customElements.get('mpc-whatsapp-order')) {
    customElements.define(
      'mpc-whatsapp-order',
      class extends HTMLElement {
        connectedCallback() {
          if (this.whatsappBound) return;
          this.whatsappBound = true;

          this.addEventListener('click', (event) => {
            if (!event.target.closest('.mpc-whatsapp-button')) return;
            event.preventDefault();
            event.stopPropagation();

            const form =
              this.closest('form') ||
              this.closest('product-form-component')?.querySelector('form') ||
              document.getElementById(this.dataset.formId);

            if (!form) {
              alert('Ürün seçimi okunamadı. Sayfayı yenileyip tekrar deneyin.');
              return;
            }

            const variantId = form.elements.namedItem('id')?.value;
            const variants = JSON.parse(this.dataset.variants || '[]');
            const optionNames = JSON.parse(this.dataset.options || '[]');
            const variant = variants.find(
              (item) => String(item.id) === String(variantId)
            );

            if (!variant) {
              alert('Lütfen model ve renk seçiminizi tamamlayın.');
              return;
            }

            if (!variant.available) {
              alert('Seçtiğiniz model ve renk şu anda stokta yok.');
              return;
            }

            const quantity = Math.max(
              1,
              parseInt(
                form.elements.namedItem('quantity')?.value || '1',
                10
              ) || 1
            );

            const lines = [
              'Merhaba, bu ürünü sipariş vermek istiyorum.',
              '',
              'Ürün: ' + this.dataset.title
            ];

            variant.options.forEach((value, index) => {
              if (value !== 'Default Title') {
                lines.push(
                  (optionNames[index] || 'Seçenek') + ': ' + value
                );
              }
            });

            const productUrl = new URL(
              this.dataset.url,
              window.location.origin
            );
            productUrl.searchParams.set('variant', variant.id);

            lines.push('Adet: ' + quantity);
            lines.push('Ürün bağlantısı: ' + productUrl.href);

            const whatsappUrl =
              'https://wa.me/905355179090?text=' +
              encodeURIComponent(lines.join('\n'));

            window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
          });
        }
      }
    );
  }
